'use client';

import { useTranslation } from 'react-i18next';
import { IonIcon } from '@ionic/react';
import { IonRouterLink } from '@ionic/react';
import { personAddOutline } from 'ionicons/icons';
import { GolfAvatar } from '../ui/GolfAvatar';

type FriendRequestItemProps = {
  userId: string;
  senderInfo: {
    name: string;
    username: string;
    avatar: string;
  };
};

export function FriendRequestAcceptedNotification({ senderInfo }: FriendRequestItemProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-full space-x-3 py-4">
      {/* Notification icon on the left */}
      <div className="flex-shrink-0 mt-1">
        <div className="flex items-center justify-center size-8 rounded-full bg-primary/10">
          <IonIcon icon={personAddOutline} className="size-4 text-primary" />
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1">
        <div className="flex items-start justify-between">
          {/* Sender info and text */}
          <div className="flex flex-col">
            <IonRouterLink href={`/u/${encodeURIComponent(senderInfo?.username || '')}`}>
              <GolfAvatar
                imageUrl={senderInfo?.avatar}
                size={32}
              />
            </IonRouterLink>

            <p className="text-sm">
              <IonRouterLink href={`/u/${encodeURIComponent(senderInfo?.username || '')}`} className="mr-1 font-semibold hover:underline text-sm">
                {senderInfo?.name}
              </IonRouterLink>
              {t('followed_you_back')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
